import { useState } from 'react';
import { useAuthContext } from '../features/auth/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export const useLogout = () => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const { logout: contextLogout } = useAuthContext();
  const navigate = useNavigate();
  
  const logout = async () => {
    console.log('🔄 Starting logout process...');
    setIsLoggingOut(true);
    
    try {
      await contextLogout();
      console.log('✅ Context logout completed, navigating to login...');
      
      // Navigate to login page
      navigate('/login', { replace: true });
    } catch (error) {
      console.log('❌ Logout error:', error);
      // Even if logout fails, still navigate to login page
      // since local data has been cleared by the context
      navigate('/login', { replace: true });
    } finally {
      setIsLoggingOut(false);
      console.log('✅ Logout process completed');
    }
  };
  
  const clearAuthDataAndRedirect = () => {
    console.log('🔄 Clearing auth data and redirecting...');
    // This is handled by the AuthContext
    navigate('/login', { replace: true });
  };
  
  return { 
    logout, 
    isLoggingOut, 
    clearAuthDataAndRedirect 
  };
}; 